// Texte für /community/stream (NT-STREAM-PARTNERKARTEN-01).
// Reine Anzeige-Werte, deshalb im Frontend gepflegt (kein Shared-Import). Entwürfe — Chris passt sie an.

/** Leerzustand-Sprüche, nur sichtbar wenn niemand live ist. */
export const STREAM_EMPTY_LINES: readonly string[] = [
  'MR. WEEDMAN LIEFERT GERADE EIS.',
  'DER CHAT SITZT GERADE U-HAFT AB.',
  'ALLE KAMERAS SIND GERADE ZUFÄLLIG AUS.',
  'DIE STREAMER ZÄHLEN GERADE BARGELD.',
  'DAS SIGNAL WIRD GERADE ABGEHÖRT.',
  'JEMAND HAT DAS STROMKABEL GEKLAUT.',
  'DIE MIKROFONE WERDEN AUF WANZEN GEPRÜFT.',
  'DER LETZTE STREAM WURDE BESCHLAGNAHMT.',
  'GERADE IST RAZZIA IM STUDIO.',
  'DIE STREAMER HABEN EIN ALIBI. ANGEBLICH.',
];

export const STREAM_EMPTY_HEADLINE = 'NIEMAND IST GERADE LIVE.';
export const STREAM_EMPTY_FOOTER = 'SCHAU SPÄTER NOCHMAL VORBEI.';

let pickedEmptyLine: string | null = null;

/**
 * Ein Spruch pro Seitenaufruf: wird beim ersten Bedarf gewürfelt und bleibt danach stabil,
 * damit der Text beim 60s-Polling nicht flackert.
 */
export function getEmptyLine(): string {
  if (pickedEmptyLine === null) {
    const buf = new Uint32Array(1);
    crypto.getRandomValues(buf);
    const index = (buf[0] ?? 0) % STREAM_EMPTY_LINES.length;
    pickedEmptyLine = STREAM_EMPTY_LINES[index] ?? STREAM_EMPTY_LINES[0] ?? '';
  }
  return pickedEmptyLine;
}

/** Nur für Tests: setzt die gemerkte Auswahl zurück. */
export function resetEmptyLine(): void {
  pickedEmptyLine = null;
}
